// extracted by mini-css-extract-plugin
export default {"chatWrapper":"Chat_chatWrapper__ib7Om"};